<table class="w-full price-list-product-elements-table" mat-table #table [dataSource]="dataSource" fusePerfectScrollbar>
  <ng-container matColumnDef="name">
    <th mat-header-cell *matHeaderCellDef i18n>Название</th>
    <td mat-cell *matCellDef="let item">{{ item.name }}</td>
  </ng-container>

  <ng-container matColumnDef="materialName">
    <th mat-header-cell *matHeaderCellDef i18n>Материал</th>
    <td mat-cell *matCellDef="let item">
      {{ formatMaterialName(item.materialName) }}
    </td>
  </ng-container>

  <ng-container matColumnDef="article">
    <th mat-header-cell *matHeaderCellDef i18n>Артикул</th>
    <td mat-cell *matCellDef="let item">
      {{ item.article }}
    </td>
  </ng-container>

  <ng-container matColumnDef="changeMaterial">
    <th mat-header-cell *matHeaderCellDef i18n></th>
    <td mat-cell *matCellDef="let item">
      <button
        i18n
        *ngIf="item.materialsToReplaceCount > 1 || processingMode === 0"
        mat-stroked-button
        (click)="openRecomendedMaterialsDialog(item)"
        >Изменить</button
      >

      <button
        i18n
        mat-stroked-button
        *ngIf="
          item.materialsToReplaceCount <= 1 &&
          cuttingOptions.cuttingProductSettings.addMaterialsFromMatBase &&
          processingMode !== 0
        "
        (click)="openMaterialBaseDialog(item)"
        >Изменить</button
      >

      <button
        i18n
        disabled
        *ngIf="item.materialsToReplaceCount <= 1 && !cuttingOptions.cuttingProductSettings.addMaterialsFromMatBase"
        mat-stroked-button
        >Изменить</button
      >
    </td>
  </ng-container>

  <ng-container matColumnDef="edge">
    <th mat-header-cell *matHeaderCellDef i18n>Облицовка</th>
    <td mat-cell *matCellDef="let item">
      <button mat-icon-button (click)="openEdgeDialog(item)" [disabled]="!item.edgeList?.length">
        <mat-icon>border_style</mat-icon>
      </button>
    </td>
  </ng-container>

  <ng-container matColumnDef="count">
    <th mat-header-cell *matHeaderCellDef i18n>Количество</th>
    <td mat-cell *matCellDef="let item">
      {{ item.count }}
    </td>
  </ng-container>

  <ng-container matColumnDef="delete">
    <th mat-header-cell *matHeaderCellDef i18n></th>
    <td mat-cell *matCellDef="let item">
      <button mat-icon-button (click)="deleteElement(item)">
        <mat-icon>delete</mat-icon>
      </button>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
</table>
